var _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 81,
    fill: "none",
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    y: 0.855,
    fill: "#fff",
    fillOpacity: 0.08,
    rx: 40
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.584,
    cy: 39.696,
    r: 6.25,
    fill: "#5B9300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.938 49.25a13.5 13.5 0 0 0-3.857-2.696 8.9 8.9 0 0 0 3.313-6.942c0-4.947-4.125-9.005-9.072-8.929-4.87.076-8.794 4.045-8.794 8.929a8.92 8.92 0 0 0 3.312 6.942 13.4 13.4 0 0 0-3.857 2.696 13.3 13.3 0 0 0-3.91 9.103.357.357 0 0 0 .356.366h2.5a.356.356 0 0 0 .357-.344 10.1 10.1 0 0 1 2.978-6.852 10.12 10.12 0 0 1 7.201-2.983c2.719 0 5.277 1.059 7.201 2.983a10.13 10.13 0 0 1 2.978 6.852.355.355 0 0 0 .357.344h2.5a.357.357 0 0 0 .357-.366 13.28 13.28 0 0 0-3.92-9.103m-9.473-3.924a5.67 5.67 0 0 1-4.04-1.674 5.67 5.67 0 0 1-1.674-4.098 5.72 5.72 0 0 1 1.62-3.929 5.7 5.7 0 0 1 4.036-1.727 5.75 5.75 0 0 1 4.063 1.633 5.67 5.67 0 0 1 1.714 4.08c0 1.528-.594 2.96-1.674 4.041a5.68 5.68 0 0 1-4.045 1.674M33.282 40.79q-.061-.582-.062-1.178.002-1.065.191-2.076a.36.36 0 0 0-.2-.393 5.6 5.6 0 0 1-1.648-1.12 5.7 5.7 0 0 1-1.727-4.26 5.7 5.7 0 0 1 1.62-3.82 5.68 5.68 0 0 1 4.16-1.729 5.7 5.7 0 0 1 4.75 2.626c.09.138.264.196.416.142a11 11 0 0 1 2.469-.553.358.358 0 0 0 .281-.518 8.94 8.94 0 0 0-7.844-4.906c-4.95-.076-9.076 3.982-9.076 8.924a8.91 8.91 0 0 0 3.313 6.942 13.4 13.4 0 0 0-3.862 2.696 13.28 13.28 0 0 0-3.92 9.107.357.357 0 0 0 .358.366h2.504a.356.356 0 0 0 .357-.343 10.1 10.1 0 0 1 2.978-6.853 10.1 10.1 0 0 1 4.674-2.665.36.36 0 0 0 .268-.389"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernance);
export default __webpack_public_path__ + "static/media/governance.1a6f03105ecca6ea6fd24b6970df2fde.svg";
export { ForwardRef as ReactComponent };